module.exports = __webpack_public_path__ + "static/media/010.5b071a56.jpg";